// extracted by mini-css-extract-plugin
export default {"wrap":"status_wrap__gLQBo","content":"status_content__k39M3","image":"status_image__QUM-4"};